import {
    CLEAR_REPORT_DATA,
    FETCH_AGREEMENTS,
    LOAD_TERMS_CONDITIONS,
    SIGNED_AGREEMENT,
    SET_LOGGEDIN_USER,
    FETCH_AGREEMENTS_SIGNED_LOADED,
    TOGGLE_TERMS
} from '../actions/types';
import { updateObject } from '../utility';

const initialState = {
    loggedInUserTCPermission: false,
    loggedInUserAccountName: '',
    userIpAddress: '',
    loggedInUserTerms: {},
    termsAndConditions: {},
    termsNotify: false,
    signedAgreements: [],
    isUserAgreementSignedLoaded: false,
    firstTimeUserLogin: false,
    openCloseTerms: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_AGREEMENTS:
            return updateObject(state, {
                signedAgreements: action.signedAgreements.data
            });
        case FETCH_AGREEMENTS_SIGNED_LOADED:
            return updateObject(state, {
                isUserAgreementSignedLoaded: action.payload
            });
        case CLEAR_REPORT_DATA:
            return updateObject(state, {
                signedAgreements: []
            });
        case SIGNED_AGREEMENT:
            return updateObject(state, {
                loggedInUserTerms: action.signedAgreement,
                firstTimeUserLogin: true
            });
        case LOAD_TERMS_CONDITIONS:
            return updateObject(state, {
                termsAndConditions: action.termsAndConditions,
                termsNotify: action.termsNotify
            });
        case TOGGLE_TERMS:
            return updateObject(state, {
                openCloseTerms: action.payload
            });
        case SET_LOGGEDIN_USER:
            return updateObject(state, {
                loggedInUserTCPermission: action.loggedInUserTCPermission,
                loggedInUserTerms: action.loggedInUserTerms,
                loggedInUserAccountName: action.loggedInUserAccountName,
                userIpAddress: action.userIpAddress
            });
        default:
            return state;
    }
};
